<script>
  export let iconCls ="fa fa-shopping-cart";
  export let textColorCls ="text-white";
  export let btnColorCls ="btn-primary";
  export let onClick;
</script>
<button type="button" class={`btn btn-rounded py-1 px-2 ${btnColorCls}`} on:click={onClick}>
  <i class={`${iconCls} ${textColorCls}`}></i>
</button>
